var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeuMei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2388_5195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2388_5195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.7561C10.6 11.7561 9.41667 11.2846 8.45 10.3415C7.48333 9.39837 7 8.2439 7 6.87805C7 5.54471 7.48333 4.39837 8.45 3.43902C9.41667 2.47967 10.6 2 12 2C13.4 2 14.5833 2.47967 15.55 3.43902C16.5167 4.39837 17 5.54471 17 6.87805C17 8.2439 16.5167 9.39837 15.55 10.3415C14.5833 11.2846 13.4 11.7561 12 11.7561ZM12 10.2927C12.9667 10.2927 13.7833 9.95935 14.45 9.29268C15.1167 8.62602 15.45 7.82114 15.45 6.87805C15.45 5.96748 15.1167 5.17886 14.45 4.51219C13.7833 3.84553 12.9667 3.51219 12 3.51219C11.0333 3.51219 10.2167 3.84553 9.55 4.51219C8.88333 5.17886 8.55 5.96748 8.55 6.87805C8.55 7.82114 8.88333 8.62602 9.55 9.29268C10.2167 9.95935 11.0333 10.2927 12 10.2927ZM2.4 22C1.96667 22 1.625 21.8699 1.375 21.6098C1.125 21.3496 1 21.0244 1 20.6341L1 19.2683C1 18.6504 1.15833 18.1138 1.475 17.6585C1.79167 17.2033 2.3 16.7805 3 16.3902C4.4 15.6423 5.85833 15.0894 7.375 14.7317C8.89167 14.374 10.4333 14.1951 12 14.1951C13.5667 14.1951 15.1083 14.374 16.625 14.7317C18.1417 15.0894 19.6 15.6423 21 16.3902C21.6667 16.7805 22.1667 17.2033 22.5 17.6585C22.8333 18.1138 23 18.6504 23 19.2683V20.6341C23 21.0244 22.875 21.3496 22.625 21.6098C22.375 21.8699 22.0333 22 21.6 22H12H2.4ZM12 15.6585C10.4 15.6585 8.8 15.8943 7.2 16.3659C5.6 16.8374 4.01667 17.5285 2.45 18.439L2.45 20.5366H21.55V18.3902C20.0167 17.4797 18.4417 16.7967 16.825 16.3415C15.2083 15.8862 13.6 15.6585 12 15.6585Z",
    fill: "#58C5C6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeuMei);
export default __webpack_public_path__ + "static/media/meu_mei.28885ff101acdf2ab5995873f508a288.svg";
export { ForwardRef as ReactComponent };